<template>
  <div>
    <HomeBaseLabel :question="question" />
    <v-radio-group hide-details="auto" v-model="question.Value">
      <v-radio
        v-for="(option, index) in question.Options"
        :key="index"
        :label="option.Text"
        :value="option.Value"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "RadioBase",
  components: {
    HomeBaseLabel,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
